import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-component-loader',
    templateUrl: './component-loader.component.html',
    styleUrls: ['./component-loader.component.scss'],
    standalone: false
})
export class ComponentLoaderComponent {
    @Input() diameter: number = 100;
    @Input() minHeight?: number;
}
